import React, { useState,useEffect, useRef }  from 'react';
import './Blogs.css'; // Add your custom CSS styles
import {config} from '../../config/config'
import '../Landing Page/LandingPage copy.css';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';   
import { HelmetProvider, Helmet } from 'react-helmet-async';
import placeholderImage from "../../assets/placeHolder.jpg";
import Footer from '../../components/Footer';
import Buy from '../Subscription/Buypremium';
import Header from '../../components/Header';
const Blogpage = () => {
  const googleanalytics  = process.env.REACT_APP_GOOGLE_ANALYITCS_ID;
  const googleAuthRef = useRef(null);
  const menuRef = useRef(null);
  const dropdownRef = useRef(null); 
  const currentYear = new Date().getFullYear();
  

  const { title } = useParams(); 

  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(`${config.baseURL}/getFullBlog.php?slug=${encodeURIComponent(title)}`, {
          method: "GET",
        });
  
        if (response.ok) {
          const data = await response.json();
  
          if (data.status === "success") {
            setBlog(data.data); // Set the full blog data
             window.scrollTo(0, 0);
          } else {
            console.error("Blog not found:", data.message);
          }
        } else {
          console.error("Failed to fetch blog");
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
      }
    };
  
    fetchBlog();
  }, [title]);
  
  
  

const renderContentWithLineBreaks = (content) => {
  if (!content) return 'Something Went Wrong';

  // Step 1: Replace /n with actual newline characters (\n)
  let formattedContent = content.replace(/\/n/g, '\n'); // Replace /n with \n

  // Step 2: Replace all \n with <br /> for line breaks
  formattedContent = formattedContent.replace(/(\r\n|\n)/g, '<br />');
  
  return formattedContent;
};

  




      
  return (
    <HelmetProvider>
    <div className="landing-page">

<Helmet>
        <title>{blog?.title || 'Something Went Wrong'}</title>
        <meta name="description" content={blog?.question || 'Something Went Wrong'} />
        <meta name="keywords" content={blog?.summary || 'Something Went Wrong'} />
        <link rel="canonical" href={blog?.slug ? `https://generator.video/blog/${encodeURIComponent(blog.slug)}/` : "https://generator.video/blog/"} />

        {blog?.image_url && <link rel="preload" href={blog.image_url} as="image" />}
      </Helmet>
    <Header/>
    <div className='Hero_landing-page'>
      <h1 className='Hero_title'>Text to video Blog</h1>
    <h2 className='Hero-subtitle'>Discover the amazing things you'll create with AI</h2>
      
    </div>


    {/* Blog Content Section */}
    <div className="blogspage_top_blogsfull">
    <div className="blogspage_top_content_blogsfull">
      <h1>{blog?.question || 'Something Went Wrong'}</h1>
      
      <Link to="/Dashboard" style={{ textDecoration: 'none', color: 'white' }} className="view-dashboard">
        Create Video
      </Link>
    </div>
    <div className="blogspage_top_image_blogsfull">
      <img src={blog?.image_url || {placeholderImage}} alt={blog?.title || 'Blog image'} loading="lazy" width='200px' height='200px'/>
    </div>
  </div>

  <div className="blog-page_blogsfull">
   {/* <h2 className="blog-title_blogsfull">{blog?.title || 'Something Went Wrong'}</h2>
     <div className="blog-image-container_blogsfull">
      <img className="blog-image_blogsfull" src={blog?.image_url || config.placeholderImage} alt={blog?.title || 'Blog image'} width='200px' height='200px' />
    </div>
    <p
      className="blog-content_blogsfull"
      dangerouslySetInnerHTML={{
        __html: renderContentWithLineBreaks(blog?.content || ''),
      }}
    /> */}
    <div className="blog-content_blogsfull" dangerouslySetInnerHTML={{ __html: blog?.content || '' }} />

  </div>
    

<Buy showBackButton={false} noMargin={true}  />
   

   <Footer/>
    
    </div>
    </HelmetProvider>
  );
}

export default Blogpage;
